import fetch from 'tools/fetch'

const findPlaceFromQuery = async (searchString) => {
  try {
    const res = await fetch(`https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${searchString}&returnGeom=Y&getAddrDetails=Y`, {})
    // Filter out NIL postal address
    return res.results.filter(r => r.POSTAL !== 'NIL').map((address) => {
      const formattedAddress = [address.BLK_NO, address.ROAD_NAME, address.BUILDING].filter(x => x && x !== 'NIL').join(' ')
      return {
        formattedAddress: `${formattedAddress}, Singapore, ${address.POSTAL}`,
        addressOne: formattedAddress,
        postal: address.POSTAL,
        country: 'Singapore',
        latitude: address.LATITUDE,
        longitude: address.LONGITUDE
      }
    })
  } catch (e) {
    return []
  }
}

const getApiHealthStatus = async () => {
  try {
    const response = await fetch('https://www.onemap.gov.sg/api/common/elastic/search?searchVal=Oddle&returnGeom=N&getAddrDetails=N', {}, false)
    return response.status === 200
  } catch (e) {
    return false
  }
}

export default () => ({
  getApiHealthStatus,
  findPlaceFromQuery
})
